module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/bikes/bikes-delete/bikes-delete.component.css
// module id = ./src/app/bikes/bikes-delete/bikes-delete.component.css
// module chunks = main